import axios from "axios";
import { message } from "antd";
import { removeLoginInfo, updateToken, accessToken } from "../utils/token";
import { fetchRefreshToken } from "../api/login";
import { showval, Encrypt, getAESkey, Decrypt } from "./secret";
import { MD5 } from "./md5";
const apiPrefix = process.env.REACT_APP_API_PREFIX;
const baseFetch = axios.create({
  baseURL: apiPrefix,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
  withCredentials: true,
});

// const handleRequireLogin = (code, url) => {
//     // code 401代表需要登录才可以
//     if (code === 401) {
//         console.log(code, url);
//     }
// };
baseFetch.interceptors.request.use((config) => {
  // console.log(config, config.url)
  const { url } = config;

  if (!!sessionStorage.getItem("loginInfo")) {
    let timestamp = new Date().getTime();
    let nonce_str = showval();
    config.headers.access_token = JSON.parse(
      sessionStorage.getItem("loginInfo")
    ).accessToken;
    config.headers.timestamp = timestamp;
    config.headers.nonce_str = nonce_str;
    config.headers.sign = MD5(timestamp + "&" + nonce_str + "&" + getAESkey());
  }

  return config;
});
baseFetch.setToken = (token) => {
  updateToken(token);
};
// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];
baseFetch.interceptors.response.use((res) => {
  if (res.data.resultCode === 30001) {
    // token 失效，直接移除 token
    message.error(res.data.message);
    removeLoginInfo();
    window.location.reload();
  }
  if (res.data.resultCode === 30002) {
    //需要刷新token
    const config = res.config;
    if (!isRefreshing) {
      isRefreshing = true;
      return fetchRefreshToken()
        .then((res) => {
          let data = Decrypt(res.data);

          baseFetch.setToken(data);
          // config.headers['data'] = data;
          config.baseURL = "";
          // 已经刷新了token，将所有队列中的请求进行重试
          requests.forEach((cb) => cb(data));
          requests = [];
          return baseFetch(config);
        })
        .catch((res) => {
          console.error("refreshtoken error =>", res);
          window.location.href = "/";
        })
        .finally(() => {
          isRefreshing = false;
        });
    } else {
      // 正在刷新token，将返回一个未执行resolve的promise
      return new Promise((resolve) => {
        // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        requests.push((token) => {
          config.baseURL = "";
          // config.headers['authorization'] = token;
          resolve(baseFetch(config));
        });
      });
    }
  }

  return res;
});
const fetch = async (
  url,
  config = {
    method: "get",
  }
) => {
  try {
    const { data, status } = await baseFetch({
      method: config.method,
      url,
      data: config.body || config.data,
      params: config.params,
    });
    if (!data.success && data.resultCode !== 30002) {
      message.error(data.message);
    }
    return data;
  } catch (error) {
    message.error(error.response.data.message);
    throw error.response.data.message;
  }
};

export default fetch;
